<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <v-breadcrumbs>
            <v-breadcrumbs-item>
              <router-link to="/">Home</router-link>
            </v-breadcrumbs-item>
            <span class="divider">></span>
            <v-breadcrumbs-item disabled>
              Parking Lots
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row no-gutters class="px-5">
        <v-col cols="12">
          <h1>Parking Lots</h1>
          <h3>Parking Space Numbering on 12th December, 2018</h3>

          <v-row>
            <v-col cols="10" v-for="zone in parkingZones" :key="zone.title">
                <v-card class="px-12 py-8 mb-6">
                    <v-table>
                        <thead>
                            <tr :style="{ backgroundColor: zone.bgcolor }">
                                <th colspan="4">{{ zone.title }}</th>
                            </tr>
                            <tr>
                                <th>Code</th>
                                <th>Parking Places</th>
                                <th>Parking Lot No.</th>
                                <th>Total No. of P/Lot</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in zone.rows" :key="row.code">
                                <td>{{ row.code }}</td>
                                <td>{{ row.place }}</td>
                                <td>{{ row.lotNumber }}</td>
                                <td>{{ row.totalLots }}</td>
                            </tr>
                            <tr>
                                <td colspan="3" class="font-weight-bold">Total</td>
                                <td class="font-weight-bold">{{ zone.total }}</td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" class="mt-12">
                <p class="font-weight-medium mb-3 text-center">
                    MAJLIS BANDARAYA MIRI <br>
                    REKOD PARKING LOT DI MIRI CITY COUNCIL MULTI-STOREY CARPARK <br>
                    (BANGUNAN LETAK KERETA BERTINGKAT, MSCP)
                </p>

                <v-card class="px-12 py-8 mb-6">
                    <v-table>
                        <thead>
                            <tr>
                                <th>Bil</th>
                                <th>Level / Tingkat</th>
                                <th>No. Petak</th>
                                <th>Jumlah Setiap Tingkat</th>
                                <th>Rumusan</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>2A</td>
                                <td>1 - 60</td>
                                <td>57</td>
                                <td>
                                    1. 4 parking lot deducted for OKU parking & for OKU parking 4 parking lots affected equal to 2 parking lots <br>
                                    2. 1 parking (Parking lots no. 1) deducted for MCC car reserved.
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>2B</td>
                                <td>61 - 66</td>
                                <td>6</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>3A</td>
                                <td>67 - 177</td>
                                <td>51</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>3B</td>
                                <td>178 - 225</td>
                                <td>50</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>4A</td>
                                <td>226 - 345</td>
                                <td>72</td>
                                <td>3 parking lots has been deducted for MCC toilet</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>4B</td>
                                <td>346 - 393</td>
                                <td>50</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>5A</td>
                                <td>394 - 506</td>
                                <td>113</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>5B</td>
                                <td>507 - 552</td>
                                <td>45</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="3" class="font-weight-bold">Total</td>
                                <td class="font-weight-bold">444</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-card>
            </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'ParkingLotsPage',
  data() {
    return {
      parkingZones: [
        {
          title: "Blue Zone - Section One",
          rows: [
            { code: "BR / 1A", place: "Central Parking Area No. 3", lotNumber: "1 to 98", totalLots: 98 },
            { code: "BR / 1B", place: "Taman Muhibbad", lotNumber: "1 to 133", totalLots: 133 },
            { code: "PONDOKS", place: "Tamu Muhibbah", lotNumber: "A", totalLots: 0 },
            { code: "", place: "CPA No. 3", lotNumber: "B", totalLots: 0 },
          ],
          total: 231,
          bgcolor: "#a8c9e8",
        },
        {
          title: "Blue Zone - Section One",
          rows: [
            { code: "B / 1C", place: "Jalan Kingsway", lotNumber: "1 to 62", totalLots: 62 },
            { code: "B / 1D", place: "Lorong 1 Backlane/SEDC Building", lotNumber: "1 to 88", totalLots: 88 },
            { code: "B / 1E", place: "Jalan Bendahara", lotNumber: "1 to 60", totalLots: 60 },
            { code: "B / 1F", place: "Lorong 2 Backlane, CPA No. 2, High Street", lotNumber: "1 to 74", totalLots: 74 },
            { code: "B / 1G", place: "China Street", lotNumber: "1 to 33", totalLots: 33 },
            { code: "B / 1H", place: "Junction of Kingsway & Kwangtung/Jln Chia Tze Chin(85)Miri Heritage", lotNumber: "1 to 171", totalLots: 171 },
            { code: "B / 1D", place: "Melayu Rd Centre Point", lotNumber: "1 to 695", totalLots: 695 },
            { code: "B / 1D", place: "Kubu Rd Centre Point 2", lotNumber: "1 to 316", totalLots: 316 },
            { code: "B / 1D", place: "Kwantung Rd Chop/MCMC", lotNumber: "1 to 82", totalLots: 82 },
          ],
          total: 1536,
          bgcolor: "#a8c9e8",
        },
        {
            title: "Blue Zone - Section Two",
            rows: [
            { code: "B / 2A", place: "Nahkoda Gampar Street", lotNumber: "1 to 62", totalLots: 62 },
            { code: "B / 2B", place: "Brooke Road Triangle Car Park", lotNumber: "1 to 91", totalLots: 91 },
            { code: "B / 2C", place: "Public Latrine, Persiaran Kabor West Backlane", lotNumber: "1 to 51", totalLots: 51 },
            { code: "B / 2D", place: "Jalan Bendahara", lotNumber: "1 to 68", totalLots: 68 },
            { code: "B / 2E", place: "Jalan Bendahara (Gardenia)", lotNumber: "1 to 35", totalLots: 35 },
            { code: "B / 2F", place: "Jalan Maju", lotNumber: "1 to 49", totalLots: 49 },
            { code: "B / 2G", place: "South Yu Seng, Halaman Kabor", lotNumber: "1 to 82", totalLots: 82 },
            { code: "B / 2H", place: "Nahkoda Gampar Backlane, P.K.E. Backlane, Jln Maju Backlane", lotNumber: "1 to 63", totalLots: 63 },
            { code: "B / 2I", place: "Nahkoda Gampar Street", lotNumber: "1 to 51", totalLots: 51 },
            { code: "B / 2J", place: "South Yu Seng", lotNumber: "1 to 48", totalLots: 48 },
            { code: "B / 2K", place: "Lee Tak Street, Nahkoda Gampar, Merbau Road", lotNumber: "1 to 117", totalLots: 117 },
            { code: "B / 2L", place: "Jalan Bendahara (Muamalat Bank)", lotNumber: "1 to 51", totalLots: 51 },
            { code: "PONDOKS", place: "Broke Road", lotNumber: "C", totalLots: 0 },
            { code: "", place: "Nahkoda Gampar", lotNumber: "D", totalLots: 0 },
            ],
            total: 768,
            bgcolor: "#a8c9e8",
        },
        {
            title: "Blue Zone - Section Three",
            rows: [
            { code: "B / 3A", place: "Jalan Bendahara", lotNumber: "1 to 138", totalLots: 138 },
            { code: "B / 3B", place: "Jalan Permaisuri", lotNumber: "1 to 86", totalLots: 86 },
            { code: "B / 3C", place: "Jalan Permaisuri", lotNumber: "1 to 55", totalLots: 55 },
            { code: "B / 3D", place: "Lorong Sekolah", lotNumber: "1 to 83", totalLots: 83 },
            { code: "B / 3E", place: "Jalan Yu Seng Utara", lotNumber: "1 to 49", totalLots: 37 },
            { code: "B / 3F", place: "Jalan Masjid", lotNumber: "1 to 33", totalLots: 33 },
            { code: "B / 3G", place: "Jalan Calandra", lotNumber: "1 to 49", totalLots: 49 },
            { code: "B / 3H", place: "Jalan Zinia, Jalan Ansella", lotNumber: "1 to 38", totalLots: 38 },
            { code: "B / 3I", place: "Jalan Helenium, Jalan Mucuna, Jalan Stapelia", lotNumber: "1 to 120", totalLots: 120 },
            { code: "B / 3J", place: "Jalan Tritonia", lotNumber: "1 to 33", totalLots: 33 },
            { code: "B / 3K", place: "Jalan Merpati, Jalan Sida, Jalan Torenia", lotNumber: "1 to 219", totalLots: 219 },
            { code: "B / 3L", place: "Jalan Jurinea, Jalan Reseda", lotNumber: "1 to 61", totalLots: 61 },
            { code: "B / 3M", place: "Jln Royal (Merpati)", lotNumber: "1 to 69", totalLots: 69 },
            { code: "PONDOKS", place: "Water front / Malayan Banking", lotNumber: "E", totalLots: 0 },
            { code: "", place: "Jalan Calandra", lotNumber: "F", totalLots: 0 },
            ],
            total: 1021,
            bgcolor: "#a8c9e8",
        },
        {
            title: "Blue Zone - Section Four & Five",
            rows: [
            { code: "B / 4A", place: "Jalan Parry Shopping Centre", lotNumber: "1 to 151", totalLots: 151 },
            { code: "B / 4B", place: "Jalan Post", lotNumber: "1 to 94", totalLots: 94 },
            { code: "B / 4C", place: "Jalan Bintang Jaya 1, Jalan Bintang Jaya 5", lotNumber: "1 to 138", totalLots: 138 },
            { code: "B / 4D", place: "Jalan Bintang Jaya Utama", lotNumber: "1 to 82", totalLots: 82 },
            { code: "B / 4E", place: "Jalan Bintang Jaya 2, Jalan Bintang Jaya 3, Jalan Bintang Jaya 4", lotNumber: "1 to 128", totalLots: 128 },
            { code: "B / 4F", place: "Jalan Bendahara (Water Front)", lotNumber: "1 to 512", totalLots: 512 },
            { code: "B / 4G", place: "Jalan Bendahara (Tune Hotel)", lotNumber: "1 to 306", totalLots: 306 },
            ],
            total: 1324,
            bgcolor: "#a8c9e8",
        },
        {
            title: "Green Zone - Section One",
            rows: [
            { code: "GB/ 5A", place: "LorongSepuluh(Regional Market & Adj. Shopping Area)", lotNumber: "1 to 250", totalLots: 250 },
            { code: "G / 5B", place: "Lorong Sepuluh", lotNumber: "1 to 147", totalLots: 147 },
            { code: "PONDOK", place: "Jalan Post", lotNumber: "G", totalLots: 0 },
            { code: "", place: "Krokop lorong 10", lotNumber: "H", totalLots: 0 },
            { code: "", place: "Jalan Bintang", lotNumber: "I", totalLots: 0 },
            ],
            total: 379,
            bgcolor: "#bfe0b9",
        },
        {
            title: "Green Zone - Section 6",
            rows: [
            { code: "GB/ 6A", place: "Jalan Pelita Utama", lotNumber: "1 to 216", totalLots: 216 },
            { code: "G / 6F", place: "Jalan Pelita Satu", lotNumber: "1 to 156", totalLots: 156 },
            { code: "G / 6C", place: "Jalan Pelita Dua", lotNumber: "1 to 143", totalLots: 143 },
            { code: "G / 6D", place: "Jalan Pelita Tiga", lotNumber: "1 to 120", totalLots: 120 },
            { code: "G / 6E", place: "Jalan Pelita Empat / Jalan Pelita Lima", lotNumber: "1 to 184", totalLots: 184 },
            { code: "G / 6B", place: "Jalan Ngo King Hi", lotNumber: "1 to 162", totalLots: 162 },
            { code: "PONDOK", place: "Jln Ngo King Hi", lotNumber: "J", totalLots: 0 },
            ],
            total: 981,
            bgcolor: "#bfe0b9",
        },
        {
            title: "Green Zone - Section 7, 8 & 9",
            rows: [
            { code: "G / 8A", place: "Jalan Boulevard Satu", lotNumber: "1 to 237", totalLots: 237 },
            { code: "G / 8B", place: "Jalan Boulevard 1 A", lotNumber: "1 to 79", totalLots: 79 },
            { code: "G / 8C", place: "Jalan Boulevard 1 B", lotNumber: "1 to 22", totalLots: 22 },
            { code: "G / 8D", place: "Jalan Boulevard 2", lotNumber: "1 to 252", totalLots: 252 },
            { code: "G / 8E", place: "Jalan Boulevard 2A & 2B", lotNumber: "1 to 112", totalLots: 112 },
            { code: "G / 8G", place: "Jalan Boulevard 2C", lotNumber: "1 to 70", totalLots: 70 },
            { code: "G / 8H", place: "Persiaran Utama", lotNumber: "1 to 123", totalLots: 123 },
            { code: "G / 8I", place: "Jalan Boulevard 3", lotNumber: "1 to 118", totalLots: 118 },
            { code: "G / 8J", place: "Jalan Boulevard 3A/3B", lotNumber: "1 to 54", totalLots: 54 },
            { code: "G / 8L", place: "Jalan Boulevard 3C", lotNumber: "1 to 46", totalLots: 46 },
            { code: "G / 7A", place: "Taman Faradel", lotNumber: "1 to 184", totalLots: 184 },
            { code: "G / 7B", place: "Taman Yakin", lotNumber: "1 to 302", totalLots: 302 },
            { code: "G / 7C", place: "Pasar Lorong 5", lotNumber: "1 to 158", totalLots: 158 },
            { code: "G / 7D", place: "Jalan Bulan Sabit", lotNumber: "1 to 92", totalLots: 92 },
            { code: "G / 9A", place: "Saberkas Com. Centre", lotNumber: "1 to 278", totalLots: 278 },
            { code: "G / 9B", place: "Saberkas Com. Centre", lotNumber: "1 to 288", totalLots: 288 },
            ],
            total: 2415,
            bgcolor: "#bfe0b9",
        },
        {
            title: "Green Zone - Section 10 & 12",
            rows: [
            { code: "G / 12A", place: "Morsjaya Utama", lotNumber: "1 to 290", totalLots: 290 },
            { code: "G / 12C", place: "Morsjaya Dua", lotNumber: "1 to 126", totalLots: 126 },
            { code: "G / 12D", place: "Morsjaya Empat", lotNumber: "1 to 41", totalLots: 41 },
            { code: "G / 12H", place: "Morsjaya Tujuh", lotNumber: "1 to 86", totalLots: 86 },
            { code: "G / 10", place: "Kings Commercial Centre", lotNumber: "1 to 86", totalLots: 86 },
            ],
            total: 629,
            bgcolor: "#bfe0b9",
        },
        {
            title: "Green Zone - Section 11, 13 & 14",
            rows: [
            { code: "G / 11", place: "Telang Usan", lotNumber: "1 to 63", totalLots: 63 },
            { code: "G / 13A", place: "Bulatan comm. Centre", lotNumber: "1 to 389", totalLots: 389 },
            { code: "G / 13B", place: "Bulatan Com. Centre (Miri Court food)", lotNumber: "1 to 142", totalLots: 142 },
            { code: "G / 17", place: "Jalan Brighton (Shoplots)", lotNumber: "0", totalLots: 0 },
            ],
            total: 594,
            bgcolor: "#bfe0b9",
        }
      ],
    };
  },

};
</script>